export const AUTH_ACTION_TYPES = {
  SEND_OTP_SUCCESS: 'SEND_OTP_SUCCESS',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGOUT_APP: 'LOGOUT_APP',
  SIGNUP_REQUEST_SUCCESS: 'SIGNUP_REQUEST_SUCCESS'
};
